import React from 'react';
import styled from 'styled-components';
import { BREAKPOINT } from '@latitude/core/utils/constants';
import Typography from '@latitude/typography';

const FAQ_HERO_DATA = {
  title: 'Frequently Asked Questions',
  subtitle: 'Got a burning question? You may find your answer here.',
};

const FaqHero = () => (
  <StyledHero>
    <StyledHeroInner>
      <Typography.H3 color="#fff" >{FAQ_HERO_DATA.title}</Typography.H3>
      <Typography.Body color="#fff">{FAQ_HERO_DATA.subtitle}</Typography.Body>
    </StyledHeroInner>
  </StyledHero>
);

const StyledHero = styled.div`
  background: linear-gradient(135deg, #1b1bb3 0%, #0a6cff 100%);
  border-bottom-left-radius: 80px;
  display: flex;
  align-items: center;

  /* mobile (base) */
  min-height: 260px;
  padding: 40px 24px;
  margin: 0;

  /* desktop */
  @media (min-width: ${BREAKPOINT.LG}) {
    border-bottom-left-radius: 120px;
    padding: 0 56px;
    min-height: 400px;
    margin: 64px 0 96px; 
  }
`;

const StyledHeroInner = styled.section`
  max-width: 1140px;
  width: 100%;         
  margin: 0 auto;
  padding: 0 24px;
.typography-base__h3 {
  margin-bottom: 16px !important;
  line-height: 40px !important;

  @media (max-width: ${parseInt(BREAKPOINT.LG) - 1}px) {
    font-size: 32px !important;
  }
}
`;

export default FaqHero;